<template>
  <div>
    <ArSearch :queryParams="queryParams" :fullDate="fullDate"/>
    <ArList :queryParams="queryParams" :fullDate="fullDate" :fieldItems="fieldItems" />
  </div>
</template>
<script>

import ArSearch from "./component/ArStatistics/ArSearch";
import DatePicker from "vue2-datepicker";
import ArList from "./component/ArStatistics/ArList";
const moment = require("moment");

export default {
  components: {
    ArList,
    DatePicker,
    ArSearch
  },
  data() {
    return {
      fullDate: [],
      queryParams: {
        excel_rtype: 'AR',
        product_type_code: 'all',
        option_type: 'all',
        view_type: 'VIEW',
        start_date: '',
        end_date: '',
        keyword: '',
      },
      fieldItems: [{
        'rnum': {
          'label': '번호',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        },
      }, {
        'p_code': {
          'label': '상품코드',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        },
        // 'visible': true,
      } , {
        'top_type_name': {
          'label': '대분류',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        },
        // 'visible': true,
      }, {
        'p_name': {
          'label': '상품명',
          'thStyle': {
            'vertical-align': 'middle',
            'text-align': 'center'
          }
        }
      },  {
        'custom_date': {
          'label': '출시일',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'product_reg_date': {
          'label': '등록일',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'price_or_point': {
          'label': '금액',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'view_name': {
          'label': '노출여부',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'total_cnt': {
          'label': 'total_cnt',
          'class': 'text-center',
          'sortable': true,
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'reg_info': {
          'label': '등록자',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }],
    }
  },
  computed: {
  },
  watch: {},
  mounted: function() {

  },
  methods: {
    getFormatDate(date) {
      if (!date) return;
      return moment(date).format("YYYY-MM-DD");
    },

    chagefield(view_type){
      let label_nm = '';
      if (view_type == 'VIEW'){
        label_nm = '조회수';
      } else if (view_type == 'RECOMMAND'){
        label_nm = '추천수';
      } else if (view_type == 'DOWNLOAD'){
        label_nm = '다운로드수';
      } else if (view_type == 'RESEARCH'){
        label_nm = '후속연구요쳥수';
      }

      this.fieldItems = this.fieldItems.map(item => {
        if (item.hasOwnProperty('total_cnt')) {
          item.total_cnt.label = label_nm; // 'your_new_label'을 원하는 새로운 레이블로 바꾸세요.
        }
        return item;
      });
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/statistics/content/ContentArStatistics.vue